import React from 'react';
import PropTypes from 'prop-types';
import formatOreToKroner from '../lib/formatOreToKroner';
import { data as agreementDataPropTypes } from './agreementPropTypes';
import partnerPropTypes from './partnerPropTypes';

const AgreementReceipt = ({ agreement, partner, role }) => {
    const isSeller = role === 'SELLER';
    const totalLabel = isSeller ? 'Totalt til deg' : 'Du betaler';
    const totalAmount = isSeller
        ? agreement.total
        : agreement.total + agreement.fee;
    return (
        <div className="bg-ice r-pal">
            <div className="line phm">
                <div className="unit size2of3 leftify">
                    Avtalt pris for varen
                </div>
                <div className="unit size1of3 rightify">
                    {formatOreToKroner(agreement.amount)}
                </div>
            </div>

            {agreement.freight > 0 ? (
                <div className="line phm mtm">
                    <div className="unit size2of3 leftify">
                        {isSeller
                            ? `${partner.name} betaler frakt`
                            : 'Du betaler frakt'}
                    </div>
                    <div className="unit size1of3 rightify">
                        {formatOreToKroner(agreement.freight)}
                    </div>
                </div>
            ) : (
                <div className="line phm mtm">
                    <div className="unit size2of3 leftify">
                        {isSeller ? (
                            <span>
                                <strong>OBS:</strong> Du er ansvarlig for frakt
                            </span>
                        ) : (
                            `${partner.name} betaler frakt`
                        )}
                    </div>
                </div>
            )}

            {!isSeller && (
                <div className="line phm mtm">
                    <div className="unit size2of3 leftify">Gebyr til FINN</div>
                    <div className="unit size1of3 rightify">
                        {formatOreToKroner(agreement.fee)}
                    </div>
                </div>
            )}

            <hr />

            <div className="line phm mtm">
                <div className="unit size2of3 leftify strong">{totalLabel}</div>
                <div className="unit size1of3 rightify strong">
                    {formatOreToKroner(totalAmount)}
                </div>
            </div>

            {!isSeller && (
                <p className="phm mtm mln">
                    {partner.name} får {formatOreToKroner(agreement.total)}.
                </p>
            )}

            {isSeller && (
                <p className="phm mtm mln">
                    {partner.name} har i tillegg betalt{' '}
                    {formatOreToKroner(agreement.fee)} i gebyr for tjenesten.
                </p>
            )}
        </div>
    );
};

AgreementReceipt.propTypes = {
    agreement: agreementDataPropTypes.isRequired,
    partner: partnerPropTypes.isRequired,
    role: PropTypes.oneOf(['BUYER', 'SELLER']),
};

export default AgreementReceipt;



// WEBPACK FOOTER //
// ./safeTrade/agreementReceipt.jsx